import { DataBean } from "../DataBean";

export class DeleteKpiEmploye extends DataBean {

    public async deleteKpiEmployeeMeasurement(idKpi: any, from: any, upto: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteKpiEmployeeMeasurement_Number_java.util.Date_java.util.Date", [idKpi, from, upto]);
    }
}
